import { MenuItem } from "@mui/material";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { User, AppContext } from "../../context/appContext";
import { endpoints } from "../../endpoints/endpoints";

const SetDefaultPassword = ({
  userId,
  disabled,
}: {
  userId: number;
  disabled: boolean;
}): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const setPassword = async (): Promise<void> => {
    await axios
      .post(endpoints.admin.setDefaultPassword, {
        sessionId: user.sessionId,
        userId: userId,
      })
      .then(async (response) => {
        checkSession(response);

        if (response.data.meta.status === "success") {
          enqueueSnackbar("Passwort wurde auf Kennwort21 gesetzt", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Fehler beim setzen des Standardpassworts.", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error changing participant status", error);
      });
  };

  return (
    <MenuItem disabled={disabled} onClick={setPassword}>
      Standardpasswort setzen
    </MenuItem>
  );
};

export default SetDefaultPassword;
